/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersapprove1Inputs */

const en_membersapprove1 = /** @type {(inputs: Membersapprove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const de_membersapprove1 = /** @type {(inputs: Membersapprove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annehmen`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Membersapprove1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersapprove1 = /** @type {((inputs?: Membersapprove1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersapprove1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersapprove1(inputs)
	return de_membersapprove1(inputs)
});
export { membersapprove1 as "membersApprove" }